import { forwardRef, PropsWithChildren, Ref } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { TabBar, TabProps } from '@revolut-internal/ui-kit'

interface ITabBarLinkProps extends PropsWithChildren, Omit<TabProps, 'children'> {
  to: string
}

export const TabBarLink = forwardRef(
  ({ to, children, ...rest }: ITabBarLinkProps, ref: Ref<HTMLInputElement>) => (
    <TabBar.Item ref={ref} use={RouterLink} to={to} {...rest}>
      {children}
    </TabBar.Item>
  ),
)
